// RUM の計測対象パスを管理するモジュール。
// 管理画面・内部ツールのパス（blocklist）以外はすべて計測対象とする。
// 主目的は JSエラー検出のため、新しいページが追加されても自動的に計測対象になる。

// 管理画面・内部ツールとして除外するパスのプレフィックス一覧
const ADMIN_PATH_PREFIXES = [
  "/supervisor",
  "/admins",
  "/rails_admin",   // 保険: 実際は /supervisor 配下だが念のため
  "/sidekiq",       // 保険: 実際は /supervisor 配下だが念のため
  "/letter_opener", // 開発用メールビューア（本番では非アクセスだが念のため）
];

// 末尾スラッシュを除去してパスを正規化する。ルート "/" はそのまま返す
export const normalizePath = (path) => {
  if (path === "/") {
    return path;
  }

  const normalized = path.replace(/\/+$/, "");
  return normalized.length > 0 ? normalized : "/";
};

// 管理画面のパスかどうかを判定する（プレフィックス一致）
export const isAdminPath = (path) => {
  const normalizedPath = normalizePath(path);
  return ADMIN_PATH_PREFIXES.some((prefix) => normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`));
};

// RUM を有効にすべきパスかどうかを判定する。
// 管理画面パス（ADMIN_PATH_PREFIXES）以外はすべて対象とする。
export const isRumTargetPath = (path) => {
  return !isAdminPath(normalizePath(path));
};
